"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgStepForward(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M1 1.418C1 .246 2.048-.37 3.047.255l17.641 10.923c.975.601.96 1.8-.032 2.373L3.04 23.776c-1.008.588-2.04-.04-2.04-1.202zM22.184 0c.388 0 .708.288.759.662l.007.104v22.46a.766.766 0 01-1.525.104l-.007-.104V.766c0-.423.343-.766.766-.766zM2.531 1.737v20.562l17.142-9.949L2.53 1.737z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgStepForward;
exports.default = _default;